class InlineFormset {
    constructor(formset) {
        this.formset = formset;
        this.currentHighest = parseInt(this.formset.getAttribute('data-subform-count'));
        this.init();
    }

    init() {
        this.formset.addEventListener('click', (event) => {
            if (event.target.getAttribute('data-behaviour') === 'inlineformset-remove-row') {
                event.preventDefault();
                const row = event.target.parentNode;
                this.removeRow(row);
            }
        });

        const addButton = this.formset.querySelector('[data-behaviour="inlineformset-add-row"]');
        addButton.addEventListener('click', e => {
            e.preventDefault();
            this.addRow();
        });
        this.formset.insertAdjacentElement('beforeend', addButton);

    }

    handleClick(event) {
        const target = event.target;
        if (target.classList.contains('add-row')) {
            this.addRow(target);
        } else if (target.classList.contains('remove-row')) {
            this.removeRow(target);
        }
    }

    addRow() {
        const template = this.formset.querySelector('[class="inline-formset-template"]').innerHTML;
        const formList = this.formset.querySelector('[class="inline-formset-forms"]');

        formList.insertAdjacentHTML('beforeend', template.replace(
            /XtemplateX/g,
            this.currentHighest + 1
        ));
        this.currentHighest++;
    }

    removeRow(row) {
        row.remove();
    }
}

export default InlineFormset;
